/**
 * Tracking pixels for Meta (Facebook/Instagram) and TikTok.
 * Both are only injected AFTER the user accepts cookies — matches the GDPR
 * cookie banner behaviour. Env vars:
 *   REACT_APP_META_PIXEL_ID   — 15-digit Meta Pixel ID
 *   REACT_APP_TIKTOK_PIXEL_ID — TikTok pixel ID (e.g. C1AB2CD3EF4GH5IJ6KL7)
 * If either env var is unset the corresponding pixel is silently skipped so
 * dev/preview environments never fire real analytics.
 */

const CONSENT_KEY = "ep-cookies-consent";
let loaded = false;

function hasConsent() {
  try { return localStorage.getItem(CONSENT_KEY) === "accepted"; }
  catch { return false; }
}

function loadMeta(pixelId) {
  if (typeof window === "undefined" || window.fbq) return;
  /* eslint-disable */
  !(function(f,b,e,v,n,t,s){
    if(f.fbq)return; n=f.fbq=function(){ n.callMethod ? n.callMethod.apply(n,arguments) : n.queue.push(arguments) };
    if(!f._fbq) f._fbq=n; n.push=n; n.loaded=!0; n.version="2.0"; n.queue=[];
    t=b.createElement(e); t.async=!0; t.src=v; s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

function loadTikTok(pixelId) {
  if (typeof window === "undefined" || window.ttq) return;
  /* eslint-disable */
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = w[t] = w[t] || []; ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
    ttq.load = function (e, n) {
      var r = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      n = document.createElement("script"); n.type = "text/javascript"; n.async = !0; n.src = r + "?sdkid=" + e + "&lib=" + t;
      var o = document.getElementsByTagName("script")[0]; o.parentNode.insertBefore(n, o);
    };
  })(window, document, "ttq");
  /* eslint-enable */
  window.ttq.load(pixelId);
  window.ttq.page();
}

export function initTracking() {
  if (loaded || !hasConsent()) return;
  const metaId = process.env.REACT_APP_META_PIXEL_ID;
  const ttId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
  if (metaId) loadMeta(metaId);
  if (ttId) loadTikTok(ttId);
  loaded = true;
}

export function trackPageView() {
  if (!hasConsent()) return;
  if (typeof window === "undefined") return;
  if (window.fbq) window.fbq("track", "PageView");
  if (window.ttq) window.ttq.page();
}

/**
 * Fire a Purchase / CompletePayment conversion event.
 * @param {number} value - amount charged in GBP (e.g. 5 or 10)
 * @param {string} contentId - product identifier
 */
export function trackPurchase({ value, contentId = "cosmic_birth_chart", currency = "GBP" }) {
  if (!hasConsent()) return;
  if (typeof window === "undefined") return;
  if (window.fbq) {
    window.fbq("track", "Purchase", { value, currency, content_ids: [contentId], content_type: "product" });
  }
  if (window.ttq) {
    window.ttq.track("CompletePayment", {
      value, currency, contents: [{ content_id: contentId, content_type: "product", content_name: "Cosmic Birth Chart Reading" }],
    });
  }
}

/** Consent handler — called by the cookie banner when the user clicks Accept. */
export function onConsentChange() { initTracking(); }
